<template>
  <div>
    <!-- Expansion Switch -->
    <v-layout align-center>
      <v-switch
        v-model="expanded"
        color="msr"
        :hint="$t(switchHint)"
        persistent-hint
        :label="$t('setTimeFrame')"
        data-cy="timeframe-controls-switch"
      />
      <v-progress-circular
        v-if="loading && expanded"
        class="mt-5 msr--text"
        indeterminate
        :size="30"
      />
    </v-layout>
    <v-layout
      v-if="expanded"
      column
    >
      <div
        v-if="$store.getters.userCanWriteToAtLeastOneHMP"
        class="mt-3 warning--text"
      >
        {{ $t('timeframePrecisionHint') }}
      </div>
      <!-- Dropdown -->
      <v-select
        ref="select"
        :value="orderedSelectedTimeframes"
        multiple
        item-value="id"
        return-object
        :loading="loading"
        :items="timeframes"
        :placeholder="$t('pleaseChoose')"
        :no-data-text="$t('noTimeFramesAvailable')"
        hide-details
        @change="(val) => (selectedTimeframes = val)"
      >
        <!-- Options -->
        <template
          slot="item"
          slot-scope="data"
        >
          <v-list-tile-avatar>
            <v-checkbox
              color="msr"
              :input-value="isSelectedTimeframe(data.item)"
            />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <template v-if="data.item.name">
              <v-list-tile-title>
                {{ data.item.name }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ describeWeekdays(data.item.weekdays) }}:
                {{ data.item.start }} - {{ data.item.end }}
              </v-list-tile-sub-title>
            </template>
            <template v-else>
              <v-list-tile-title class="grey--text text--darken-3">
                {{ describeWeekdays(data.item.weekdays) }}:
                {{ data.item.start }} - {{ data.item.end }}
              </v-list-tile-title>
            </template>
          </v-list-tile-content>
        </template>
        <!-- Selection -->
        <template
          slot="selection"
          slot-scope="data"
        >
          <v-chip
            label
            class="less-padding my-2 mr-3 transparent clickable"
          >
            <v-icon
              color="msr"
              class="mr-2"
            >
              timelapse
            </v-icon>
            <v-layout
              v-if="data.item.name"
              column
            >
              <span class="subheading">{{ data.item.name }}</span>
              <span class="grey--text text--darken-3">
                {{ describeWeekdays(data.item.weekdays) }}:
                {{ data.item.start }} - {{ data.item.end }}
              </span>
            </v-layout>
            <v-layout
              v-else
              column
            >
              <span class="subheading">
                {{ describeWeekdays(data.item.weekdays) }}:
                {{ data.item.start }} - {{ data.item.end }}
              </span>
            </v-layout>
          </v-chip>
        </template>
      </v-select>
      <!-- Link to management page -->
      <div
        class="ml-auto mt-3 pseudo-anchor--inverted msr--text"
        data-cy="timeframe-management-link-btn"
        @click.stop="confirmGoToManageTimeframesPage()"
      >
        {{ $t('timeframeManagement') }}
      </div>
    </v-layout>
  </div>
</template>

<script>
import orderBy from 'lodash.orderby';

import {describeWeekdays} from '@/mixins/weekdays';

export default {
  props: {
    switchHint: {
      type: String,
      default: 'timeFrameSwitchHint',
    },
  },
  data() {
    return {
      expanded: false,
      loading: false,
      selectedTimeframes: [],
    };
  },
  computed: {
    timeframes() {
      return this.$store.state.common.timeframes;
    },
    orderedSelectedTimeframes() {
      return orderBy(this.selectedTimeframes, [
        'name',
        'weekdays',
        'start',
        'end',
      ]);
    },
  },
  watch: {
    /**
     * Keep timeframes list up to date and avoid UI/data mismatch.
     */
    expanded: function (expanded) {
      if (expanded) {
        this.fetchTimeframes();
      } else {
        // Deselect current timeframes.
        this.selectedTimeframes = [];
      }
    },
  },
  methods: {
    describeWeekdays: describeWeekdays,
    isSelectedTimeframe(timeframe) {
      return this.selectedTimeframes.map((x) => x.id).includes(timeframe.id);
    },
    getSelectedTimeframes() {
      return this.selectedTimeframes;
    },
    fetchTimeframes() {
      this.loading = true;
      return this.$store.dispatch('LIST_TIMEFRAMES').finally(() => {
        this.loading = false;
      });
    },
    initializeWith(timeframes) {
      if (!timeframes || !timeframes.length) {
        this.expanded = false;
        return;
      }
      this.expanded = true;
      this.selectedTimeframes = timeframes;
    },
    confirmGoToManageTimeframesPage() {
      const confirmed = confirm(this.$t('confirmPageNavigationFromDialog'));
      if (!confirmed) {
        return;
      }
      this.$router.push('/timeframes');
    },
  },
};
</script>

<style scoped>
.v-chip.less-padding >>> .v-chip__content {
  padding: 0px 4px;
}

.v-select-list >>> .v-list__tile--active i.fix-option-selected-color {
  color: var(--msr-color-primary);
}
</style>



// WEBPACK FOOTER //
// src/components/TimeframeControls.vue